import { CustomTable, NakedTable } from "components";
import { useQuery } from "react-query";
import apiService from "services/api";
import { FiSearch } from "react-icons/fi";
import { Link } from "react-router-dom";
import { useState } from "react";
import { CustomInput } from "reactstrap";
import { FilterableTable } from "components/FilterableTable";

const lowHoursCourseTableColumns = [
  {
    id: "Centre",
    header: "Centre",
    accessor: (row) => <small>{row?.studentDetail.centre.shortName}</small>,
    filterable: true,
    sortable: true,
  },
  {
    id: "Student",
    header: "Student",
    accessor: (row) => (
      <small>{`${row?.studentDetail.firstName} ${row?.studentDetail.lastName}`}</small>
    ),
    filterable: true,
    sortable: true,
  },
  {
    id: "Course",
    header: "Course",
    accessor: (row) => <small>{row?.courseDetail.name}</small>,
    filterable: true,
    sortable: true,
  },
  {
    id: "HoursLeft",
    header: "Hours Left",
    accessor: (row) => <small>{row?.hoursLeft}</small>,
    sortable: true,
    filterable: true,
  },
  {
    id: "action",
    header: "View",
    alignment: "center",
    accessor: (row) => (
      <Link
        className="d-flex justify-content-center"
        to={`/student/${row?.studentDetail?.id}`}
      >
        <FiSearch
          size={20}
          className="text-warning mr-2"
          style={{ cursor: "pointer" }}
        />
      </Link>
    ),
    sortable: false,
    filterable: false,
  },
];

const LowHourCoursePage = () => {
  const { data, isLoading } = useQuery(
    ["student", "low-hours"],
    apiService.student.lowHoursCourse,
  );
  const [hoursCount, setHoursCount] = useState();
  return (
    <div className="content">
      <FilterableTable
        data={data}
        defaultPageSize={20}
        query={(filters) => () =>
          apiService.student.lowHoursCourse.get(undefined, {}, filters)
        }
        title="Student Courses with Low Hours Left"
        actionPrepend
        queryKey="studentRecords"
        columns={lowHoursCourseTableColumns}
        filters={[
          {
            filterName: "hours_left",
            operator: "equals",
            placeholder: "5 (default)",
            type: "number",
            label: "Hours Left",
          },
          { filterName: "centre", operator: "contains", placeholder: "Centre" },
          {
            filterName: "student_name",
            operator: "contains",
            placeholder: "Student Name",
          },
          {
            filterName: "course_name",
            operator: "contains",
            placeholder: "Subject",
          },
        ]}
      />
    </div>
  );
};

export default LowHourCoursePage;
